class InlineFormWrapper extends HTMLElement {
  constructor() {
    super()
    this.formEmbedElem = null
    this.internalFormElem = null
  }

  connectedCallback() {
    this.init()
  }

  async init() {
    this.formEmbedElem = await this.catchForm()
    if (this.formEmbedElem) {
      this.internalFormElem =
        this.formEmbedElem.shadowRoot.querySelector('form')
    }
    if (this.internalFormElem) {
      this.applyPhoneNumberFieldCustomization()
      this.applyNamesFieldsSideBySide()
    }
  }

  async applyPhoneNumberFieldCustomization() {
    const phoneNumberInputElem =
      this.internalFormElem.querySelector('input[type="tel"]')

    if (phoneNumberInputElem) {
      phoneNumberInputElem.parentElement.style.width = '100%'
      phoneNumberInputElem.parentElement.parentElement.style.display = 'flex'

      phoneNumberInputElem.value = '+1 '
      phoneNumberInputElem.dispatchEvent(new Event('input'))
    }

    const countrySelectorDropdownElem = this.internalFormElem.querySelector(
      'button[aria-controls="country-selector-dropdown"]'
    )
    if (countrySelectorDropdownElem) {
      countrySelectorDropdownElem.parentElement.style.display = 'none'
    }

    const phoneCountrySelectorElem = this.internalFormElem.querySelector(
      '.phone-country-selector'
    )
    if (phoneCountrySelectorElem) {
      phoneCountrySelectorElem.style.display = 'none'
    }
  }

  async applyNamesFieldsSideBySide() {
    if (this.dataset.namesFieldsSideBySide == 'true') {
      const firstNameInputElem =
        this.internalFormElem.querySelector('input#first_name')
      const lastNameInputElem =
        this.internalFormElem.querySelector('input#last_name')

      if (firstNameInputElem && lastNameInputElem) {
        const nameWrapper = document.createElement('div')
        nameWrapper.classList.add('shopify-form__name-fields-wrapper')

        nameWrapper.style.display = 'flex'
        nameWrapper.style.gap = '10px'
        nameWrapper.style.width = '100%'

        firstNameInputElem.parentElement.style.width = '100%'
        lastNameInputElem.parentElement.style.width = '100%'

        nameWrapper.appendChild(firstNameInputElem.parentElement)
        nameWrapper.appendChild(lastNameInputElem.parentElement)

        this.internalFormElem.insertBefore(
          nameWrapper,
          this.internalFormElem.firstChild
        )

        if (!document.getElementById('shopify-form__name-fields-style')) {
          const style = document.createElement('style')
          style.id = 'shopify-form__name-fields-style'
          style.textContent = `
            .shopify-form__name-fields-wrapper {
              flex-wrap: wrap;              
            }

            @media screen and (min-width: 750px) {
              .shopify-form__name-fields-wrapper {
                flex-wrap: nowrap;
              }
            }
          `
          this.internalFormElem.appendChild(style)
        }
      }
    }
  }

  catchForm() {
    return new Promise((resolve) => {
      const form = this.querySelector('form-embed')
      if (form) return resolve(form)

      const observer = new MutationObserver(() => {
        const detectedForm = this.querySelector('form-embed')
        if (detectedForm) {
          resolve(detectedForm)
          observer.disconnect()
        }
      })

      observer.observe(this, { subtree: true, childList: true })
    })
  }

  disconnectedCallback() {}
}

customElements.define('inline-form-wrapper', InlineFormWrapper)
